__turbopack_context__.v({
  "attributesContainer": "W7u9xW_attributesContainer",
  "attributesSkeleton": "W7u9xW_attributesSkeleton",
  "brandName": "W7u9xW_brandName",
  "hoverImage": "W7u9xW_hoverImage",
  "listItem": "W7u9xW_listItem",
  "productGrid": "W7u9xW_productGrid",
  "seeMoreText": "W7u9xW_seeMoreText",
  "translucentHoverOverlay": "W7u9xW_translucentHoverOverlay",
});
